import React from 'react'
import { Flex, Input, Typography } from 'antd'

const ModelEmply = () => {
  const { Text } = Typography

  const onChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    console.log(e)
  }

  return (
    <>
      <div className='employ__model'>
        <div className='svg__em'>
          <svg
            width='267'
            height='196'
            viewBox='0 0 267 196'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M163.355 132.732L163.353 132.733C163.027 132.852 162.679 132.924 162.317 132.944C162.236 132.948 162.155 132.949 162.074 132.949C161.732 132.944 161.402 132.89 161.089 132.796C160.656 132.667 160.257 132.462 159.909 132.192C159.782 132.095 159.663 131.986 159.55 131.873C158.896 131.209 158.495 130.295 158.509 129.29C158.512 129.028 158.545 128.774 158.602 128.528C158.629 128.409 158.659 128.292 158.698 128.178C159.187 126.734 160.561 125.703 162.167 125.724C163.321 125.738 164.343 126.294 164.992 127.144C165.467 127.766 165.744 128.542 165.734 129.383C165.714 130.928 164.727 132.234 163.355 132.732ZM165.971 126.437C165.104 125.288 163.734 124.537 162.183 124.519C160.041 124.49 158.207 125.865 157.556 127.791C157.398 128.257 157.31 128.755 157.303 129.274C157.295 129.879 157.401 130.458 157.597 130.994C157.91 131.852 158.461 132.596 159.17 133.146C159.876 133.693 160.737 134.049 161.679 134.134C161.804 134.144 161.931 134.153 162.059 134.154C162.139 134.155 162.219 134.152 162.298 134.149C162.325 134.148 162.354 134.149 162.382 134.148C162.865 134.122 163.33 134.024 163.767 133.866C165.596 133.202 166.912 131.46 166.94 129.398C166.954 128.288 166.591 127.261 165.971 126.437Z'
              fill='#4DA8F2'
            />
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M0 195.985H266.961V191.105H0V195.985Z'
              fill='#FDC748'
            />
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M118.736 41.0933C118.736 41.0933 94.922 63.7543 106.506 81.3983C118.091 99.0433 123.512 83.5883 123.512 83.5883C123.512 83.5883 131.347 85.9533 119.718 64.1983C114.237 53.9443 118.736 41.0933 118.736 41.0933Z'
              fill='#BBD070'
            />
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M74.704 16.5243C74.704 16.5243 56.513 37.9023 80.834 67.5073C105.155 97.1123 101.385 112.761 101.385 112.761C101.385 112.761 135.241 61.2903 74.704 16.5243Z'
              fill='#C3DBFF'
            />
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M106.869 103.824C118.187 106.112 109.029 73.2033 92.057 63.1703C75.085 53.1363 59.901 52.1583 50.394 42.4963C50.394 42.4963 51.135 92.5533 106.869 103.824Z'
              fill='#92BEFF'
            />
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M155.97 47.5523C155.97 47.5523 167.425 13.9593 145.566 3.54532C123.706 -6.86968 105.147 8.18532 101.641 16.3313C98.135 24.4773 99.063 39.2893 102.053 49.6183C105.043 59.9463 104.608 75.6703 98.112 80.9293C91.616 86.1873 83.562 94.9213 83.96 112.699C84.208 123.728 127.361 84.4863 127.361 84.4863L155.97 47.5523Z'
              fill='#233862'
            />
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M125.256 87.5124C125.256 87.5124 107.289 91.4944 100.157 95.6624C93.027 99.8294 77.19 119 77.19 127.243C77.19 135.486 146.447 143.186 146.447 143.186L159.574 191.111C159.574 191.111 194.58 182.569 198.747 175.484C202.915 168.399 185.452 117.624 182.463 107.348C179.414 96.8654 166.867 89.5564 152.281 87.5124C137.695 85.4694 125.256 87.5124 125.256 87.5124Z'
              fill='#FFD779'
            />
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M151.035 87.3474C151.035 87.3474 150.632 109.184 133.313 109.832C115.994 110.479 119.6 88.8874 119.6 88.8874C119.6 88.8874 132.267 83.7554 151.035 87.3474Z'
              fill='#FFB27D'
            />
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M158.362 21.4513C158.362 21.4513 164.488 56.5733 147.042 81.9443C128.974 108.22 158.362 21.4513 158.362 21.4513Z'
              fill='#233862'
            />
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M147.319 71.9073C147.319 71.9073 146.114 82.3523 148.125 88.8493C150.136 95.3453 121.645 95.5243 121.66 90.1833C121.679 84.1153 124.575 79.0463 121.847 68.6453C119.118 58.2443 147.319 71.9073 147.319 71.9073Z'
              fill='#FFB27D'
            />
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M125.218 73.2393C125.218 73.2393 134.214 82.6113 145.717 74.2173C145.717 74.2173 144.767 80.2073 136.493 80.9803C128.22 81.7543 125.218 73.2393 125.218 73.2393Z'
              fill='#ED975D'
            />
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M136.484 9.27335C136.484 9.27335 159.218 16.0014 155.97 47.5524C152.722 79.1024 137.875 77.4773 136.484 77.7104C135.091 77.9414 117.46 79.1024 111.893 40.8244C106.325 2.54635 136.484 9.27335 136.484 9.27335Z'
              fill='#FFB27D'
            />
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M130.614 23.3424C130.614 23.3424 142.968 42.9934 155.97 47.5524C155.97 47.5524 163.07 14.5784 133.747 7.66937C104.425 0.761372 109.018 40.9744 111.206 51.6974C111.206 51.6974 117.314 35.9214 130.614 23.3424Z'
              fill='#233862'
            />
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M114.045 20.3824C114.045 20.3824 120.548 7.78936 131.528 7.22636C142.509 6.66436 149.039 16.1894 149.039 16.1894C149.039 16.1894 144.752 5.46436 131.542 5.46436C118.332 5.46436 114.045 20.3824 114.045 20.3824Z'
              fill='#88C0FF'
            />
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M166.458 191.105H64.983L57.273 119.427H158.748L166.458 191.105Z'
              fill='#3F8CFF'
            />
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M62.445 187.762H163.03L155.416 116.967H54.83L62.445 187.762ZM164.016 188.645H61.651L53.846 116.082H156.211L164.016 188.645Z'
              fill='#3F8CFF'
            />
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M118.161 154.107C119.072 158.566 116.992 162.758 113.515 163.469C110.038 164.179 106.481 161.141 105.57 156.682C104.658 152.222 106.738 148.031 110.215 147.32C113.693 146.61 117.249 149.648 118.161 154.107Z'
              fill='#CAE0FF'
            />
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M156.865 191.105H175.801V183.9H156.865V191.105Z'
              fill='#3F8CFF'
            />
          </svg>
        </div>
      </div>
      <div className='contend__emModel'>
        <Text type='secondary'>Member’s Email </Text>
        <Input
          placeholder='memberemail@gmail.com'
          allowClear
          style={{ margin: '10px auto 20px auto' }}
          width={'100%'}
          size='large'
          onChange={onChange}
        />
        <Flex gap={10} align='center' className='addlist'>
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M12.9933 5.88338C12.9355 5.38604 12.5128 5 12 5C11.4477 5 11 5.44772 11 6V11H6L5.88338 11.0067C5.38604 11.0645 5 11.4872 5 12C5 12.5523 5.44772 13 6 13H11V18L11.0067 18.1166C11.0645 18.614 11.4872 19 12 19C12.5523 19 13 18.5523 13 18V13H18L18.1166 12.9933C18.614 12.9355 19 12.5128 19 12C19 11.4477 18.5523 11 18 11H13V6L12.9933 5.88338Z'
              fill='#3F8CFF'
            />
          </svg>
          <Text className='text___'>Add another Member</Text>
        </Flex>
      </div>
    </>
  )
}

export default ModelEmply
